import { render, staticRenderFns } from "./FloatingChatMessages.vue?vue&type=template&id=6eaaba8f&scoped=true&"
import script from "./FloatingChatMessages.vue?vue&type=script&lang=js&"
export * from "./FloatingChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChatMessages.vue?vue&type=style&index=0&id=6eaaba8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaaba8f",
  null
  
)

export default component.exports